import React from 'react';
import PropTypes from 'prop-types';
import { MDText } from 'i18n-react';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import { ENTITY_TYPES } from '@adsk/bim360-matrix-react-entity-linker';
import EntityPickerItem from '../../EntityPickerItem';
import { STATUS_COLOR_MAPPING } from './consts';

/**
 * A component rendering PCO entity picker item.
 * @param entity
 * @param rest
 * @returns {*}
 * @constructor
 */
const PcoEntityPickerItem = ({ entity, ...rest }) => {
  const { T } = useLocale(({ locale }) => new MDText(require(`./i18n/${locale}.json`)));

  const { id, name: title, number, status } = entity;

  const statusColor = status ? STATUS_COLOR_MAPPING[status] : null;
  const statusTextKey = status ? status.toUpperCase() : null;
  const statusText = statusTextKey ? T.translate(statusTextKey) : null;

  return (
    <EntityPickerItem
      entityType={ENTITY_TYPES.ISSUE}
      id={id}
      title={title}
      userFriendlyId={number}
      statusColor={statusColor}
      statusText={statusText}
      {...rest}
    />
  );
};

PcoEntityPickerItem.propTypes = {
  /**
   * The PCO entity we need to render.
   */
  entity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    number: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired
  }).isRequired
};

export default PcoEntityPickerItem;
